const COLOURS = {
    success: '#42f563',
    failure: '#f53858',
    info: '#c9c9c9',
    pink: '#9E3F7B',
}

export default COLOURS;